import { combineReducers } from 'redux'
import usuarios from './postsReducer'

export default combineReducers({
 usuarios
  })